import {Azienda} from "../../Admin/models/Azienda";
import {PrimaNota} from "./prima-nota";

export class Spesa extends PrimaNota{
  id?: number;
  fornitore?: number;
  fornitoreObject?: Azienda;
  fattura?: string;
  importo?: number;
  iva?: number;
  categorie?;
  note?: any;
}

